import { t } from "@/i18n";
export function Logo({ className = "" }) {
  return (
    <div className={`flex items-center gap-2.5 ${className}`} data-testid="app-logo">
      <div className="relative flex h-8 w-8 items-center justify-center rounded-lg bg-foreground text-background">
        <span className="text-sm font-extrabold tracking-tight">M</span>
        <span className="absolute -right-0.5 -top-0.5 h-2.5 w-2.5 rounded-full bg-emerald-500 ring-2 ring-background" />
      </div>
      <span className="text-[15px] font-bold tracking-tight">
        MyMenu<span className="text-emerald-500">Profit</span>
      </span>
    </div>
  );
}

export function PageHeader({ eyebrow, title, description, actions }) {
  return (
    <div className="mb-6 flex flex-col gap-4 sm:mb-8 sm:flex-row sm:items-end sm:justify-between fade-up">
      <div className="min-w-0">
        {eyebrow && <p className="eyebrow mb-2">{eyebrow}</p>}
        <h1 className="text-2xl font-extrabold tracking-tight sm:text-4xl" data-testid="page-title">{title}</h1>
        {description && <p className="mt-2 line-clamp-2 max-w-2xl text-sm text-muted-foreground sm:line-clamp-none sm:text-base">{description}</p>}
      </div>
      {actions && <div className="grid auto-cols-fr grid-flow-col gap-2 sm:flex sm:flex-wrap [&>*]:min-w-0">{actions}</div>}
    </div>
  );
}

const SEV = {
  green: { cls: "bg-emerald-500/15 text-emerald-700 dark:text-emerald-400 border-emerald-500/30", label: t("logo.faible") },
  orange: { cls: "bg-amber-500/15 text-amber-700 dark:text-amber-400 border-amber-500/30", label: t("logo.moderee") },
  red: { cls: "bg-rose-500/15 text-rose-700 dark:text-rose-400 border-rose-500/30", label: t("logo.critique") },
};

export function SeverityBadge({ severity, children, testId }) {
  const s = SEV[severity] || SEV.green;
  return (
    <span data-testid={testId} className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-xs font-semibold ${s.cls}`}>
      <span className="h-1.5 w-1.5 rounded-full bg-current" />
      {children || s.label}
    </span>
  );
}

export function EmptyState({ icon: Icon, title, description, children, testId }) {
  return (
    <div data-testid={testId} className="flex flex-col items-center rounded-xl border border-dashed bg-card/40 px-6 py-14 text-center">
      {Icon && <div className="mb-4 rounded-xl border bg-card p-3"><Icon className="h-5 w-5 text-muted-foreground" /></div>}
      <h3 className="text-base font-semibold">{title}</h3>
      {description && <p className="mt-1 max-w-md text-sm text-muted-foreground">{description}</p>}
      {children && <div className="mt-5 flex flex-wrap justify-center gap-2">{children}</div>}
    </div>
  );
}
